import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { useImmer } from "use-immer";
import { useStoreByStateListQueries } from "../../../shared/hooks/useStoreByStateListQueries";

export const useStoreByStateList = () =>
{
    const [store, setStore] = useImmer({
        search: "",
        storeByStateList:[]
      });
    const [pagination, setPagination] = useState({
      pageIndex: 1,
      pageSize: 50,
    });
      const [debouncedText] = useDebounce(store.search, 1000);
      const {listQuery} = useStoreByStateListQueries({debouncedText,pagination});

      useEffect(() => {
        if(listQuery.data)
        {
            const storesByState = listQuery.data?.map((item)=>{
              let subItems = []
              if(item.stores.length > 0)
              {
                subItems = item.stores.map((store) => {return {id:store.id,storename:store.name}});
              }
              return {id:item.id,state:item.name,subRows:subItems}
            });
            setStore(draft=>{
              draft.storeByStateList = storesByState;
            });
        } 
      }, [listQuery.data]);
      
      return {store}
};